// extracted by mini-css-extract-plugin
export default {"header":"Section_header__LT0tZ","cardWrapper":"Section_cardWrapper__se1vt","wrapper":"Section_wrapper__yE61m","toggleText":"Section_toggleText__6pB2N"};